import { composeIO } from 'react-compose-io'
import { containerPesquisaIO } from './ContainerPesquisa.IO'
import { ContainerPesquisaView } from './ContainerPesquisa.View'

export const ContainerPesquisa = composeIO(ContainerPesquisaView, containerPesquisaIO)
